export const turkish = {
    lang: 'tr',
    data: {
        Menu: {
            Project: 'Proje',
            Tag: 'Etiket',
            Department: 'Departman',
            Employees: 'Çalışanlar',
            BasicInformation: 'Temel bilgiler',
            ContactType: 'İletişim Türü',
            ApplicationSetting: 'Uygulama Ayarı',
            Employee: 'Çalışan',
            AddEmployee: 'Çalışan ekle',
            EmployeeList: 'Çalışan listesi',
            Customer: 'Müşteri',
            AddCustomer: 'Müşteri ekle',
            CustomerList: 'Müşteri listesi',
            Dashboard: 'Gösterge Paneli',
            Ticket: 'Bilet',
            AddTicket: 'Bilet ekle',
            TicketList: 'Bilet listesi',
            TicketType: 'Bilet tipi',
            Board: 'Scrum board',
            Country: 'Ülke',
            Province: 'il',
            District: 'ilçe',
            BusinessRole: 'Çalışan pozisyonu',
            OfficeEquipmentType: 'Ofis ekipman türü',
            OfficeEquipment: 'Ofis ekipman',
            AddOfficeEquipment: 'Ofis ekipman ekle',
            OfficeEquipmentList: 'Ofis ekipman listesi',
            TakeLeave: 'İzin al',
            AddTakeLeave: 'İzin günü ekle',
            TakeLeaveList: 'İzin günü listesi',
            OfficeEquipmentBrand: 'Ofis ekipman markası',
            OfficeEquipmentModel: 'Ofis ekipman modeli',
            projects: 'Projeler',
            MeetingRoom: 'Toplantı odası',
            MeetingRoomSchedule: 'Toplantı odası programı',
            Calendar: 'Takvim',
            EmployeeBoard: 'Employee board',
            CargoIntegration: 'Kargo entegrasyon',
            ERP: 'ERP ekleyin',
            Module: 'Modül',
            VirtualPos: 'Sanal pos',
            CustomerInformation: 'Müşteri bilgileri',
            projectCompanyList:'Müşteri proje listesi',
            Reports:'Raporlar',
            TicketReports:'Bilet Raporu',
            OpenTicketList: 'Açılan Bilet Raporu',
            ClosedTicketList: 'Kapanan Bilet Raporu',
            assignedEmployeeCountList: 'Atanan Bilet Raporu',
            employeeCloseTicket: 'Çözülen Bilet Raporu'
        },
        projects: 'Projeler',
        Abstentions: 'Hepsini çekimserliğe dönüştür',
        Department: 'Departman',
        AddDepartment: 'Departman ekle',
        EditDepartment: 'Departman düzenle',
        DeleteDepartment: 'Departman sil',
        DepartmentList: 'Departman listesi',
        ApplicationSetting: 'Uygulama Ayarı',
        Email: 'E-posta',
        Password: 'Parola',
        Host: 'Host',
        Port: 'Port',
        SSLCertificate: 'SSL sertifika',
        Search: 'Arama',
        Actions: 'Hareketler',
        FirstName: 'İsim',
        LastName: 'Soyadı',
        CellphoneNumber: 'Cep telefonu numarası',
        Username: 'Kullanıcı adı',
        ChangePassword: 'Şifre değiştir',
        passwordIsInvalid: 'Şifre geçersiz. Şifre en az sekiz karakter, en az bir rakam ve hem küçük hem de büyük harfler ve özel karakterler içermelidir.',
        ConfirmPassword: 'Şifreyi Onayla',
        confirmPasswordIsInvalid: 'Onay şifresi eşleşmiyor.',
        ChangePersonalInformation: 'Kişisel bilgileri değiştir',
        EmailIsInvalid: 'E-posta geçersiz.',
        SelectAll: 'Hepsini seç',
        SelectNone: 'Hiçbirini Seçme',
        PleaseCompleteTheForm: 'Lütfen formu doldurun.',
        Id: 'İd',
        IsDeleted: 'Silindi',
        Name: 'isim',
        Description: 'Açıklama',
        DateTime: 'Tarih ve saat',
        Ascending: 'Artan',
        Descending: 'Azalan',
        Employee: 'Çalışan',
        RememberMe: 'Beni hatırla',
        SignIn: 'Oturum aç',
        SignUp: 'Kaydol',
        WelcomeToEryazTicketing: 'Osa ticketing Hoş Geldiniz!',
        EryazTicketing: 'Osa ticketing',
        Notifications: 'Bildirimler',
        New: 'Yeni',
        AccessDenied: 'Erişim reddedildi',
        TaxNumber: 'vergi numarası',
        PersonalInformation: 'Kişisel bilgi',
        AddPersonalInformation: 'Kişisel bilgiler ekleyin',
        ForgotPassword: 'Parolanızı mı unuttunuz?',
        First: 'İlk',
        Prev: 'Önceki',
        Next: 'Sonraki',
        Last: 'Son',
        Send: 'Gönder',
        BackToLogin: 'Girişe geri dön',
        AnUnexpectedErrorOccurredWhileUploadingFile: 'Dosya yüklenirken beklenmeyen bir hata oluştu',
        AnEmployeeWithThisUsernameAlreadyExists: 'Bu kullanıcı adına sahip bir hesap zaten var',
        AnEmployeeWithThisNationalIdentityAlreadyExists: 'Bu ulusal kimlik koduna sahip bir hesap zaten var',
        UsernameOrPasswordIsNotCorrect: 'Kullanıcı adı veya şifre doğru değil',
        UserIsNotLogin: 'kullanıcı oturum açmadı',
        TheFileSizeIsBiggerThan3mb: 'Dosya boyutu 3mb den büyük.',
        TheAddOperationWasCompletedSuccessfully: 'Ekleme işlemi başarıyla tamamlandı.',
        TheEditOperationWasCompletedSuccessfully: 'Düzenleme işlemi başarıyla tamamlandı.',
        TheDeleteOperationWasCompletedSuccessfully: 'Silme işlemi başarıyla tamamlandı.',
        AreYouSureYouWantToDeleteTheItem: 'Öğeyi silmek istediğinizden emin misiniz?',
        CustomerLogo: 'Şirketin logosu',
        WebsiteAddress: 'İnternet adresi',
        Add: 'Ekle',
        Edit: 'Düzenle',
        Delete: 'Sil',
        Cancel: 'İptal etmek',
        MyInformation: 'Benim bilgim',
        Logout: 'Çıkış yap',
        Information: 'Bilgi',
        Image: 'Resim',
        Order: 'Aranjman',
        IdentificationNumber: 'Kimlik Numarası',
        AnAccountWithThisIdentificationNumberAlreadyExists: 'Bu ulusal kimlik koduna sahip bir hesap zaten var',
        IsActive: 'Aktif',
        Title: 'Başlık',
        Customers: 'Müşteriler',
        Customer: 'Müşteri',
        AddCustomer: 'Müşteri ekle',
        EditCustomer: 'Müşteri düzenle',
        DeleteCustomer: 'Müşteri sil',
        CustomerList: 'Müşteri listesi',
        Contact: 'İletişim',
        ContactTypeName: 'İletişim türü adı',
        AddContactType: 'İletişim Türü ekle',
        EditContactType: 'İletişim Türü düzenle',
        DeleteContactType: 'İletişim Türü sil',
        ContactTypeList: 'İletişim Türü listesi',
        ContactType: 'İletişim Türü',
        ContactTypeEnum: 'İletişim türü',
        PleaseSelectAnyItem: '-------- Lütfen herhangi bir öğe seçin -------',
        AddContact: 'İletişim ekle',
        PleaseAddContact: 'Lütfen iletişim ekleyin!',
        AddEmployee: 'Çalışan ekle',
        EditEmployee: 'Çalışan düzenle',
        DeleteEmployee: 'Çalışan sil',
        EmployeeList: 'Çalışan listesi',
        PleaseAddEmployee: 'Lütfen çalışan ekleyin!',
        AddEmployeeContact: 'Çalışan iletişim ekle',
        FullName: 'Ad Soyad',
        Address: 'Adres',
        Alert: 'Dikkat',
        PleaseCompleteAllRequiredFields: 'Lütfen tüm zorunlu alanları doldurunuz.',
        EmployeeContact: 'Çalışan irtibatı',
        Fax: 'Faks',
        Website: 'İnternet sitesi',
        PhoneNumber: 'Telefon numarası',
        Other: 'Diğer',
        IsDefault: 'Varsayılan',
        EmailDoesNotExists: 'E-posta Mevcut Değil',
        AnAccountWithThisUsernameAlreadyExists: 'Bu kullanıcı adına sahip bir hesap zaten var',
        CustomerEmployee: 'Müşteri çalışanı',
        AddCustomerEmployee: 'Müşteri çalışanı ekle',
        EditCustomerEmployee: 'Müşteri çalışanı düzenle',
        DeleteCustomerEmployee: 'Müşteri çalışanı sil',
        CustomerEmployeeList: 'Müşteri çalışanı listesi',
        Code: 'Kod',
        CreationDateTime: 'Oluşturma tarihi ve saati',
        EryazTicketingMenu: 'Osa Ticketing',
        PersonalPicture: 'Kişisel resim',
        Gender: 'Cinsiyet',
        Female: 'Kadın',
        Male: 'Erkek',
        BirthDate: 'Doğum tarihi',
        NationalIdentity: 'Kimlik Numarası',
        AnAccountWithThisNationalIdentityAlreadyExists: 'Bu ulusal kimlik koduna sahip bir hesap zaten var',
        AllTickets: 'Tüm biletler',
        ClosedTickets: 'Kapalı biletler',
        ActiveTickets: 'Aktif biletler',
        Project: 'Proje',
        AddProject: 'Proje ekle',
        EditProject: 'Proje düzenle',
        DeleteProject: 'Proje sil',
        ProjectList: 'Proje listesi',
        Tag: 'Etiket',
        AddTag: 'Etiket ekle',
        EditTag: 'Etiket düzenle',
        DeleteTag: 'Etiket sil',
        TagList: 'Etiket listesi',
        TicketType: 'Bilet tipi',
        AddTicketType: 'Bilet tipi ekle',
        EditTicketType: 'Bilet tipi düzenle',
        DeleteTicketType: 'Bilet tipi sil',
        TicketTypeList: 'Bilet tipi listesi',
        Ticket: 'Bilet',
        AddTicket: 'Bilet ekle',
        EditTicket: 'Bilet düzenle',
        DeleteTicket: 'Bilet sil',
        TicketList: 'Bilet listesi',
        Attach: 'Dosya ekle',
        Priority: 'Öncelik',
        Comment: 'Yorum',
        Status: 'Durum',
        Active: 'Aktif',
        InProgress: 'Devam etmekte',
        Closed: 'Kapalı',
        VeryHigh: 'Çok yüksek',
        High: 'Yüksek',
        Medium: 'Orta',
        Low: 'Düşük',
        VeryLow: 'Çok düşük',
        CreatorUserFullName: 'Oluşturan adı',
        IsPublic: 'Herkese açık',
        SubTask: 'Alt görev',
        AddSubTask: 'Alt görev ekle',
        EditSubTask: 'Alt görev düzenle',
        DeleteSubTask: 'Alt görev sil',
        CloseTicket: 'Bileti kapat',
        ShowSubTasks: 'Alt görevleri göster',
        HideSubTasks: 'Alt görevleri gizle',
        SubTasks: 'Alt görevler',
        Assignee: 'Atanan',
        TicketHistory: 'Bilet geçmişi',
        FromDate: 'Tarih itibaren',
        ToDate: 'Tarih kadar',
        UpdateTicketStatus: 'Bilet durumunu güncelle',
        UpdateAssignee: 'Atanan kişiyi güncelle',
        Unassigned: 'Atanmamış',
        ToDo: 'To do',
        Done: 'Tamamlandı',
        CarbonCopy: 'C.C',
        BlindCarbonCopy: 'B.C.C',
        TicketDetail: 'Bilet detayı',
        SubTaskDetail: 'Alt görev detayı',
        DepartmentName: 'Bölüm adı',
        TeamLead: 'Takım lideri',
        AddCountry: 'Ülke ekle',
        EditCountry: 'Ülkeyi düzenle',
        DeleteCountry: 'Ülkeyi sil',
        CountryList: 'Ülke listesi',
        AddProvince: 'İl ekle',
        EditProvince: 'İl düzenle',
        DeleteProvince: 'İl sil',
        ProvinceList: 'İl listesi',
        AddDistrict: 'ilçe ekle',
        EditDistrict: 'ilçe düzenle',
        DeleteDistrict: 'ilçe sil',
        DistrictList: 'ilçe listesi',
        Country: 'Ülke',
        Province: 'il',
        District: 'ilçe',
        DistrictName: 'ilçe adı',
        ProvinceName: 'İl Adı',
        CountryName: 'Ülke adı',
        PostalCode: 'Posta kodu',
        CustomerAddressType: 'Şirket adresi türü',
        BusinessRole: 'Çalışan pozisyonu',
        AddBusinessRole: 'Çalışan pozisyonu ekle',
        EditBusinessRole: 'Çalışan pozisyonunu düzenle',
        DeleteBusinessRole: 'Çalışan pozisyonunu sil',
        BusinessRoleList: 'Çalışan pozisyon listesi',
        CustomerName: 'Müşteri adı',
        TaxAdministration: 'Vergi idaresi',
        AddAddress: 'Adres ekleyin',
        PleaseAddAddress: 'Lütfen adres ekleyin',
        BillingAddress: 'Fatura Adresi',
        ShipmentAddress: 'Sevk adresi',
        ContactAddress: 'İletişim Adresi',
        SetProject: 'Proje belirlemek',
        GetTicketsFromEmail: 'E-postadan biletleri alın',
        ReceiveEmailHost: 'E-posta almak için host',
        ReceiveEmailPort: 'E-posta almak için port',
        HasOpenSubtasks: 'Açık alt görevleri var',
        Create: 'Create',
        Checked: 'Checked',
        Unchecked: 'Unchecked',
        AssignedEmployee: 'Atanan çalışan(ToDo)',
        UnassignedEmployee: 'Unassigned employee',
        AllowCloseTicket: 'Bileti kapatmaya izin ver',
        AddTakeLeave: 'İzin günü ekle',
        EditTakeLeave: 'İzin günü düzenle',
        DeleteTakeLeave: 'İzin günü sil',
        TakeLeaveList: 'İzin günü listesi',
        AddOfficeEquipment: 'Ofis ekipman ekle',
        EditOfficeEquipment: 'Ofis ekipman düzenle',
        DeleteOfficeEquipment: 'Ofis ekipman sil',
        OfficeEquipmentList: 'Ofis ekipman listesi',
        OfficeEquipmentType: 'Ofis ekipman türü',
        AddOfficeEquipmentType: 'Ofis ekipman türü ekle',
        EditOfficeEquipmentType: 'Ofis ekipman türü düzenle',
        DeleteOfficeEquipmentType: 'Ofis ekipman türü sil',
        OfficeEquipmentTypeList: 'Ofis ekipman türü listesi',
        OfficeEquipmentBrand: 'Ofis ekipman markası',
        AddOfficeEquipmentBrand: 'Ofis ekipman markası ekle',
        EditOfficeEquipmentBrand: 'Ofis ekipman markası düzenle',
        DeleteOfficeEquipmentBrand: 'Ofis ekipman markası sil',
        OfficeEquipmentBrandList: 'Ofis ekipman marka listesi',
        OfficeEquipmentModel: 'Ofis ekipman modeli',
        AddOfficeEquipmentModel: 'Ofis ekipman modeli ekle',
        EditOfficeEquipmentModel: 'Ofis ekipman modeli düzenle',
        DeleteOfficeEquipmentModel: 'Ofis ekipman modeli sil',
        OfficeEquipmentModelList: 'Ofis ekipman model listesi',
        TakeLeave: 'İzin al',
        TakeLeaveType: 'İzin türü',
        FromDateTime: 'Tarih ve saatten itibaren',
        ToDateTime: 'Tarih ve saate kadar',
        CasualAnnualLeave: 'Yıllık izin',
        SabbaticalLeave: 'Şabat izni',
        UnpaidLeave: 'Ücretli iznin',
        SickLeave: 'Hastalık izni',
        BereavementLeave: 'Yas izni',
        MaternityLeave: 'Doğum izni',
        PaternityLeave: 'Babalık izni',
        MilitaryLeave: 'Askerlik izni',
        GiftLeave: 'Hediye izni',
        SelfQuarantineLeave: 'Karantina izni',
        EmployeeFullName: 'Çalışanın tam adı',
        GivenDateTime: 'Verilen tarih ve saat',
        OfficeEquipmentTypeName: 'Ofis ekipman türü adı',
        ReturnDateTime: 'Dönüş tarihi ve saati',
        IsAccepted: 'Kabul edildi',
        ApproverFullName: 'Onaylayan adı',
        AlertModalConfirmOrRejectMessage: 'İzin talebini onaylıyor musunuz?',
        TransactionCompletedSuccessfully: 'İşlem başarıyla tamamlandı',
        AcceptOrReject: 'Kabul et veya reddet',
        Accept: 'Kabul et',
        Reject: 'Reddet',
        PleaseSelectAProject: 'Lütfen bir proje seçin',
        TheSelectedProjectIsNotBelongToTheCustomer: 'Seçilen proje müşteriye ait değildir.',
        ProjectChecklist: 'proje kontrol listesi',
        AddProjectChecklist: 'Proje kontrol listesi ekle',
        EditProjectChecklist: 'Proje kontrol listesini düzenle',
        DeleteProjectChecklist: 'Proje kontrol listesini sil',
        ProjectChecklistList: 'Proje kontrol listesi listesi',
        History: 'Kayıtlar',
        ProjectCompletionOrOngoing: 'Proje tamamlama veya devam ediyor',
        Ongoing: 'Devam ediyor',
        Remained: 'Kalan',
        StartProject: 'Projeyi başlat',
        AddStartProject: 'Proje listesi ekle',
        DeleteStartProject: 'Proje listesi sil',
        StartProjectList: 'Proje listesi',
        UpdateAssigneeForStartProject: 'Başlatma projesi için atanan kişiyi güncelle',
        StartProjectDetail: 'İşlem listesi',
        AddStartProjectDetail: 'İşlem listesi ekle',
        EditStartProjectDetail: 'İşlem listesi düzenle',
        DeleteStartProjectDetail: 'İşlem listesi sil',
        UpdateAssigneeForStartProjectDetail: 'Proje detayı için atanan güncelleme',
        UpdateProjectStatus: 'Proje durumunu güncelle',
        MeetingRoom: 'Toplantı odası',
        AddMeetingRoom: 'Toplantı odası ekle',
        EditMeetingRoom: 'Toplantı odasını düzenle',
        DeleteMeetingRoom: 'Toplantı odasını sil',
        MeetingRoomList: 'Toplantı odası listesi',
        MeetingRoomSchedule: 'Toplantı odası programı',
        AddMeetingRoomSchedule: 'Toplantı odası programı ekle',
        EditMeetingRoomSchedule: 'Toplantı odası planını düzenle',
        DeleteMeetingRoomSchedule: 'Toplantı odası programını sil',
        MeetingRoomScheduleList: 'Toplantı odası program listesi',
        Filter: 'Filtre',
        Color: 'Renk',
        MeetingRoomScheduleUsername: 'Toplantı odası programı kullanıcı adı',
        MeetingRoomSchedulePassword: 'Toplantı odası program şifresi',
        AddCargoIntegration: 'Kargo entegrasyonu ekle',
        EditCargoIntegration: 'Kargo entegrasyonunu düzenle',
        DeleteCargoIntegration: 'Kargo entegrasyonunu sil',
        CargoIntegrationList: 'Kargo entegrasyon listesi',
        AddERP: 'ERP ekleyin',
        EditERP: 'ERP düzenle',
        DeleteERP: 'ERP sil',
        ERPList: 'ERP listesi',
        AddModule: 'Modül ekle',
        EditModule: 'Modülü düzenle',
        DeleteModule: 'Modülü sil',
        ModuleList: 'Modül listesi',
        AddVirtualPos: 'Sanal pos ekle',
        EditVirtualPos: 'Sanal posu düzenle',
        DeleteVirtualPos: 'Sanal posu sil',
        VirtualPosList: 'Sanal pos listesi',
        CargoIntegration: 'Kargo entegrasyon',
        ERP: 'ERP ekleyin',
        Module: 'Modül',
        VirtualPos: 'Sanal pos',
        AllProjects: 'Tüm Projeler',
        EditDateTime: 'Düzenlenme Tarihi Ve Saati',
        YorumAciklama: 'Lütfen açıklamanızı detaylandırınız, varsa sorunun resmini ekleyiniz',
        AllowStatusChange: 'Statü değişme',
        ElapsedTime: 'Geçen zaman',
        ClosedTicketCount: 'Kapanan ticket sayısı',
        OpenTicketCount: 'Açılan ticket sayısı',
        AssignedEmployeeCountList : 'Açık ticket sayısı',
        TicketCount : 'Ticket sayısı',
        UpdateComment : 'Yorum güncelle',
        ProjectDetail : 'Proje Maddeleri',
        Level0 : 'Belirlenmemiş',
        Level1 : 'Çağrı/Çözüm',
        Level2 : 'Çağrı/Destek',
        Level3 : 'Çağrı/Yazılım',
        Level4 : 'Yazılım/Geliştirme',
        AddSubTicket : 'Alt Ticket Ekle',
        Cancelled : 'İptal'
    }
};
